import { API_URLS } from "constants/apiConstants";
import { Service } from "../types/entities";
import { ApiClient, ApiResponse } from "./requestExecutor";

export class ServicesApi extends ApiClient {
	public fetchActiveServices = async (): Promise<ApiResponse<Service[]>> => {
		try {
			let url = API_URLS.service.getAllUrl;
			return this.get<Service[]>(url) as Promise<ApiResponse<Service[]>>;
		} catch (error) {
			console.error("Error al obtener los servicios:", error);
			throw error;
		}
	};
}
